<div class="t-popup popup-patientDetails" [formGroup]="blockForm" [ngStyle]="{'direction': pageDirection}">
  <div class="t-popup-frame" style="display: flex; flex-direction:column; max-width: 47em;" cdkDrag
    cdkDragBoundary=".t-popup">
    <div class="t-popup-body">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h2 style="cursor: grab;" cdkDragHandle>
          {{'appointments.gui.labels.Set Block Details' | translate}}
        </h2>
        <button class="t-btn-popup-close" style="position: relative; top: 0; margin: 1em;" aria-label="close popup"
          (click)="closeBlockModal()"></button>
      </div>
      <ng-container *ngIf="!event">
        <!-- ======= Doctor Selection (Start) ======= -->
        <td *ngIf="!loginService?.premissions?.ApptsByRoom"><mat-form-field>
            <mat-label [ngClass]="['mat-select-value']">
              {{'appointments.gui.labels.Doctors' | translate}}
            </mat-label>
            <mat-select multiple formControlName="UID" [ngClass]="['mat-select-value','mat-form-field']">
              <ng-container *ngFor="let e of this.loginService.clinicUsers">
                <mat-option [value]="e.UID.toString()" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </td>
        <!-- ======= Doctor Selection (End) ======= -->

        <!-- ======= Room Selection (Start) ======= -->
        <td *ngIf="loginService?.premissions?.ApptsByRoom"><mat-form-field>
            <mat-label [ngClass]="['mat-select-value']">
              {{'appointments.gui.label.rooms' | translate}}
            </mat-label>
            <mat-select multiple formControlName="RID" [ngClass]="['mat-select-value','mat-form-field']">
              <ng-container *ngFor="let e of this.loginService.rooms">
                <mat-option [value]="e.AutoIndex.toString()" [ngClass]="['mat-select-value']">
                  {{ loginService.roomLabel(e) }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </td>
        <!-- ======= Room Selection (End) ======= -->
      </ng-container>

      <!-- ======= Start Date/Hour (Start) ======= -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div>
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap;">
              {{'appointments.gui.labels.Block Start Date' | translate}}
            </label>
            <i class="t-sep"></i>
            <input style="width: 6em;" [matDatepicker]="startBlockDate" formControlName="blockStartDate"
              class="t-field-text w100" />
            <img src="../../assets/icons/date.svg" (click)="startBlockDate.open()" class="clickable">
            <mat-datepicker #startBlockDate startView="month"></mat-datepicker>
          </div>
        </div>

        <div class="w30">
          <div class="l-flex l-flex-c t-field t-field-pad" style="width: 16em;">
            <label style="white-space: nowrap;">
              {{'appointments.gui.labels.Start Hour' | translate}}
            </label>
            <i class="t-sep"></i>
            <input type="time" class="t-select w100" formControlName="startHour">
          </div>
        </div>
      </div>
      <!-- ======= Start Date/Hour (End) ======= -->

      <!-- ======= End Date/Hour (Start) ======= -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details"
        style="display: flex; gap: 2em; margin: 0.5em 0 0.5em 0;">
        <div>
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap;">
              {{'appointments.gui.labels.Block End Date' | translate}}
            </label>
            <i class="t-sep"></i>
            <input style="width: 6em;" [matDatepicker]="endBlockDate" formControlName="blockEndDate"
              class="t-field-text w100" />
            <img src="../../assets/icons/date.svg" (click)="endBlockDate.open()" class="clickable">
            <mat-datepicker #endBlockDate startView="month"></mat-datepicker>
          </div>
        </div>

        <div class="w30">
          <div class="l-flex l-flex-c t-field t-field-pad" style="width: 15em;">
            <label style="white-space: nowrap;">
              {{'appointments.gui.labels.End Hour' | translate}}
            </label>
            <i class="t-sep"></i>
            <input type="time" class="t-select w100" formControlName="endHour">
          </div>
        </div>
      </div>
      <!-- ======= End Date/Hour (End) ======= -->

      <!-- ======= Duration (Start) ======= -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div style="width: min-content">
          <div class="l-flex l-flex-c t-field t-field-pad" style="white-space: nowrap">
            <label>
              {{'appointments.gui.labels.Duration' | translate}}
            </label>
            <i class="t-sep"></i>
            <input type="text" class="t-field-text w100" formControlName="duration" />
            <span style="margin-right: 5%;" *ngIf="formattedDuration.days > 0">{{ formattedDuration.days }} days</span>
            <span style="margin-right: 5%;" *ngIf="formattedDuration.days > 0 || formattedDuration.hours > 0">
              {{ formattedDuration.hours }} {{'appointments.gui.labels.hours' | translate}} &nbsp;
            </span>
            <span>
              {{ formattedDuration.minutes }} {{'appointments.gui.labels.min' | translate}} &nbsp;
            </span>
          </div>
        </div>
      </div>
      <!-- ======= Duration (End) ======= -->

      <hr class="divider">

      <!-- ======= Recurring (Start) ======= -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details"
        style="display: flex; gap: 1em; margin: 0.5em 0 0.5em 0;">
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="l-flex l-flex-c t-field t-field-pad" style="height: 3em;">
            <mat-checkbox formControlName="isRecurring" style="white-space: nowrap; margin: 0 0.5em;">
              &nbsp;{{'appointments.gui.labels.Recurring Block' | translate}}
            </mat-checkbox>
          </div>
        </div>

        <div *ngIf="blockForm.get('isRecurring').value">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label style="white-space: nowrap;">
              {{'appointments.gui.labels.Repeat Until' | translate}}
            </label>
            <i class="t-sep"></i>
            <input style="width: 6em;" [matDatepicker]="repeatUntilPicker" formControlName="repeatUntil"
              class="t-field-text w100" />
            <img src="../../assets/icons/date.svg" (click)="repeatUntilPicker.open()" class="clickable">
            <mat-datepicker #repeatUntilPicker startView="month"></mat-datepicker>
          </div>
        </div>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin patient-details" *ngIf="blockForm.get('isRecurring').value">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad" style="width: fit-content;">
            <label style="white-space: nowrap">
              {{'appointments.gui.labels.Recurrence Days' | translate}}
            </label>
            <i class="t-sep"></i>
            <mat-select multiple formControlName="daysOfWeek">
              <mat-option *ngFor="let day of daysList" [value]="day.value">
                {{ day.label | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <!-- ======= Recurring (End) ======= -->

      <hr class="divider">

      <!-- ======= Comment (Start) ======= -->
      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{'appointments.gui.labels.Comments' | translate}}
            </label>
            <i class="t-sep"></i>
            <textarea class="t-field-text w100" formControlName="comment"></textarea>
          </div>
        </div>
      </div>
      <!-- ======= Comment (End) ======= -->
      <div style="direction: ltr;">
        <!-- ======= Create/Cancel Buttons (Start) ======= -->
        <div *ngIf="!event"
          style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1em;">
          <button class="btn-cancel" matTooltip="ביטול" (click)="closeBlockModal()">
            {{'appointments.gui.buttons.Cancel' | translate}}
          </button>
          <button class="btn-ok" matTooltip="שמור חסימה" (click)="saveBlock()">
            <span class="btn-content">
              <span class="btn-icon"></span>
              <span class="btn-text">{{ 'appointments.gui.buttons.Save' | translate }}</span>
            </span>
          </button>
        </div>
        <!-- ======= Create/Cancel Buttons (End) ======= -->

        <!-- ======= Save/Edit/Delete Buttons (Start) ======= -->
        <div *ngIf="event" style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1em;">
          <button class="btn-cancel" matTooltip="{{'appointments.gui.tooltips.delete block' | translate}}"
            (click)="showDeleteAlert=true">
            <span class="btn-content">
              <span class="btn-icon"></span>
              <span class="btn-text">{{ 'appointments.gui.buttons.Delete' | translate }}</span>
            </span>
          </button>


          <div *ngIf="showDeleteAlert" class="t-validation-wrap">
            <button class="t-menu-item is-invalid-left"></button>
            <div class="t-validation-message-left" style="width: 11em; left: -15em; top: -0.5em; font-size: medium;">
              <span style="border-radius: 8px">
                <p style="margin-bottom: 1em;">
                  {{'appointments.gui.tooltips.delete block ask' | translate}}
                </p>
                <div style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw;">
                  <button class="t-menu-item" (click)="deleteBlock()">
                    {{'appointments.gui.buttons.Yes' | translate}}
                  </button>
                  <button class="t-menu-item" (click)="showDeleteAlert = false">
                    {{'appointments.gui.buttons.No' | translate}}
                  </button>
                </div>
              </span>
            </div>
          </div>
          <button class="btn-ok" matTooltip="{{'appointments.gui.tooltips.update block' | translate}}"
            (click)="updateBlock()">
            <span class="btn-content">
              <span class="btn-icon"></span>
              <span class="btn-text">{{ 'appointments.gui.buttons.Close & Update' | translate }}</span>
            </span>
          </button>
        </div>
      </div>
      <!-- ======= Save/Edit/Delete Buttons (End) ======= -->

    </div>
  </div>
</div>